export default [
  {
    title: 'breadcrumb.chat',
    route: 'chat',
    icon: 'MessageSquareIcon',
    resource: 'chat',
    action: 'read',
    tag: 0,
    tagVariant: "danger",
  },
];